<template>
  <div class="row">
    <div class="col-12 col-lg-6 c g">
        <div class="alert alert-danger text-center g" v-if="expired && !expiredschool">
            برجاء الإشتراك للإستمرار
        </div>
        <div class="alert alert-danger text-center g" v-if="expiredschool">
            <h5>المدرسة الخاصة بك غير مشتركة في خدمة من خدمات نظام التحضير الذكي.<br>
            يجب الاشتراك في اي خدمة من خدمات التحضير الذكي،<br>
            او يمكنك الاشتراك بشكل منفصل.</h5>
        </div>
        <div class="card card-body">
            <div v-if="subscribed()" class="col-12 text-center alert alert-success g">
                <h4 class="text-center">
                    إشتراكك فعال حتي <strong dir="ltr">{{ exdate}} </strong>
                </h4>
                <a href="javascript:;" @click="vvv()"><i class="fa fa-refresh"></i> تجديد الاشتراك</a>
            </div>
            <div :class="subscribed() ? 'dnone vvf text-center' : 'text-center'">
                <img :src="require('@/assets/images/subscribe.png')" style="max-width: 100%; width: 250px; margin: 0px auto">
                <br>
                <div class="mysr-form"></div>
                <template v-if="paymethod == ''">
                    <button class="btn btn-block" style="background: #9929EA; color: #fff" @click="paymethod='stcpay'; done('stcpay')" v-b-modal.pay>
                        <img :src="require('@/assets/images/stc.svg')" style="width: 24px">
                        دفع بـ STC Pay
                    </button> 
                    <button class="btn btn-dark btn-block" @click="paymethod='applepay'; done('applepay')" v-b-modal.pay>
                        <i class="fa fa-apple"></i>
                        دفع Apple Pay
                    </button> 
                    <button class="btn btn-success btn-block" @click="paymethod='creditcard'; done('creditcard')" v-b-modal.pay>
                        <i class="fa fa-cc-visa"></i>
                        دفع بالفيزا
                    </button> 
                </template>
            </div>
        </div>
    </div>
    <div class="col-12" v-if="orders.length">
        <div class="card card-body">
            <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered table-sm">
                <thead>
                    <th>
                        التاريخ
                    </th>
                    <th>
                        المبلغ
                    </th>
                    <th>
                        الحالة
                    </th>
                </thead>
                <tbody>
                    <tr v-for="order in orders" :key="order._id">
                        <td>
                            {{ order.date.split(" ")[0] }}
                        </td>
                        <td>
                            {{ order.amount }}
                        </td>
                        <td>
                            <span class="btn btn-sm btn-warning" v-if="order.status == 0" style="padding: 5px">
                                في الانتظار
                            </span>
                            <span class="btn btn-sm btn-success" v-if="order.status == 1" style="padding: 5px">
                                تم بنجاح
                            </span>
                            <span class="btn btn-sm btn-danger" v-if="order.status == 2" style="padding: 5px">
                                فشل
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            expired: window.location.href.includes("expired"),
            expiredschool: window.location.href.includes("expiredschool"),
            paymethod: "",
            user: JSON.parse(localStorage.getItem("user")),
            exdate: JSON.parse(localStorage.getItem("user")).exdate,
            orders: []
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/web/orders', {
            jwt: g.user.jwt
        })
        .then(function(r){
            g.orders = r.response
        })
        if(window.location.href.includes("callback")){
            if(window.location.href.includes("status=paid")){
                alert("تم الدفع بنجاح!", 100)
            }else{
                alert(decodeURI(window.location.href.split("message=")[1]) ,200)
            }
        }
    },
     methods: {
        vvv(){
            $(".vvf").toggle('slow')
        },
        subscribed(){
            var g = this;
            if(new Date(g.exdate).getTime() >= new Date().getTime()){
                return true;
            }
            return false;
        },
        done(m){
            var g = this;
            this.loading = true
            $.post(api + '/user/web/create-order', {
                jwt: g.user.jwt
            })
            .then(function(r){
                if(r.status == 100){
                    if(m == 'applepay'){
                        Moyasar.init({
                            element: '.mysr-form',
                            amount: r.response.amount,
                            currency: 'SAR',
                            description: 'enjazfile ' + r.response.o,
                            publishable_api_key: r.response.token,
                            callback_url: api + '/afterpayment-m?order_id=' + r.response.order_id,
                            supported_networks: ['visa', 'mastercard', 'mada'],
                            methods: ['applepay'],
                            apple_pay: {
                            country: 'SA',
                            label: 'brmja.com',
                            validate_merchant_url: 'https://api.moyasar.com/v1/applepay/initiate',
                            },
                        });
                        if(m == 'applepay'){
                            var tx = setInterval(() => {
                            if($("apple-pay-button").length){
                                clearInterval(tx)
                                setTimeout(() => {
                                    $("apple-pay-button").click()
                                }, 500);
                                }
                            }, 10);
                        }
                    }else{
                        Moyasar.init({
                            element: '.mysr-form',
                            amount: r.response.amount,
                            currency: 'SAR',
                            description: 'enjazfile ' + r.response.o,
                            publishable_api_key: r.response.token,
                            callback_url: api + '/afterpayment-m?order_id=' + r.response.order_id,
                            methods: [m]
                        });
                    }
                    var t = setInterval(() => {
                        if($(".mysr-form button").length){
                            clearInterval(t)
                            $("footer").remove()
                            $(".mysr-form").css('padding-top', "20px")
                            if(m == 'stcpay'){
                                $(".mysr-form button").click()
                            }
                        }
                    }, 10);
                }else{
                    g.paymethod = "";
                    alert("حدث خطأ, " + r.response, 200)
                }
            })
            .fail(function(){
                g.loading = false
                alert("حدث خطأ")
            })
        }
    }
}
</script>

<style>

</style>